export const serverPoint = "https://postboard.slzheng.workers.dev";
export const devServerPoint = "http://127.0.0.1:8787";
